const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "https://boardroom-reservation-be.vercel.app",
  //API_BASE_URL: process.env.REACT_APP_API_BASE_URL || "http://localhost:8000",
  };
  
  export default config;
  